(function ($) {
  'use strict';

  var initStatSlider = function () {

    //get all alumni sliders
    var $statList = $('.stat-listing--slick .js-stat-listing-items');
    //init each testimonial
    $statList.each(function () {
      //init only if it has more than one slide
      var slidesNum = $(this).find('.stat-listing__item').length;

      if (slidesNum > 1) {
        var statSlider = $(this).slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          speed: 300,
          dots: false,
          prevArrow: $($(this).closest('.stat-listing__list').find('.slick-prev')),
          nextArrow: $($(this).closest('.stat-listing__list').find('.slick-next')),
          responsive: [{
              breakpoint: 600,
              settings: {
                slidesToShow: 1
              }
            },
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
        $('.stat-listing--slick .slick-arrow').on('mousedown click', function (e) {
          e.preventDefault();
          $(e.target).blur();
        });
      }
    });
  };

  //init
  initStatSlider();
}(jQuery));